module.exports = __webpack_public_path__ + "static/UnityPoint.04e10c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/UnityPoint.jpg
// module id = 142
// module chunks = 35783957827783 202660965941462